import {
  Dialog,
  DialogActions,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { StyledDialogContentText, StyledDialogTitle } from "./style";

/**
 * MainDialog component renders a dialog with customizable title, content, and actions.
 *
 * @param {Object} props - The properties object.
 * @param {boolean} props.open - Determines whether the dialog is open.
 * @param {function} props.onClose - Callback function to handle dialog close event.
 * @param {function} props.onClickAway - Callback function to handle click away event.
 * @param {string} props.title - The title of the dialog.
 * @param {React.ReactNode} props.actions - The actions to be displayed in the dialog footer.
 * @param {string} [props.width="lg"] - The width of the dialog.
 * @param {string} [props.height="100%"] - The height of the dialog.
 * @param {React.ReactNode} props.children - The content to be displayed in the dialog body.
 * @returns {JSX.Element} The rendered MainDialog component.
 */
export default function MainDialog({
  open,
  onClose,
  onClickAway,
  title,
  actions,
  width,
  height,
  children,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClickAway}
      fullWidth={true}
      maxWidth={width || "sm"}
      PaperProps={{
        sx: { height: height },
      }}
    >
      <StyledDialogTitle>
        <Typography variant="h3">{title}</Typography>
        {onClose && (
          <IconButton aria-label="delete" onClick={onClose}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        )}
      </StyledDialogTitle>
      <StyledDialogContentText>{children}</StyledDialogContentText>
      <DialogActions>{actions}</DialogActions>
    </Dialog>
  );
}
